export const MAX_SYMBOLS_TO_BE_TRANSLATED = 150;
